<template>
  <vs-row class="mt-4" vs-w="12">
    <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-lg="5">
      <div class="mr-2 vessel-status-double-circle"></div>
      <span class="mr-2 sdf-text-20-400-light-green"
        >{{ operationMode }}{{ intervalId }}</span
      >
    </vs-col>

    <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="7">
      <span class="sdf-text-20-400-white">{{ maneuveringLastUpdateAtString }}</span>
    </vs-col>
  </vs-row>
</template>

<script>
import Vue from "vue";
import moment from "moment-timezone";

// mixins
import {
  MappingTableMixin,
  StoreCommonsMixin,
  StoreMonitoringVesselManeuveringMixin
} from "@/mixins/addon/secure-dataflow";

export default {
  mixins: [
    MappingTableMixin,
    StoreCommonsMixin,
    StoreMonitoringVesselManeuveringMixin
  ],
  components: {},
  data() {
    return {
      intervalId: null,
      timer: null,
      timerSBX: null,
      timerAMS: null,
      maneuveringLastUpdatedAt: null,
      maneuveringLastUpdateAtString: null,
      engineLastUpdatedAt: null,
      lastUpdateAt: null,
    };
  },
  watch: {
    channelDataManeuvering(val) {
      if(!val) return
      if (val.last_updated_at) {
        this.maneuveringLastUpdatedAt = moment.unix(
          val.last_updated_at.seconds
        );
        this.setWatchConnectionStateSBX();  // SB-Xの通信状態監視
        //timerAMSリセットを防ぐため一旦コメントアウト
        //if (this.engineLastUpdatedAt) this.setWatchConnectionStateAMS();  // AMSの通信状態監視
        this.updateStateTime();
      }
    },
    channelDataEngine(val) {
      if(!val) return
      if (val.last_updated_at) {
        this.engineLastUpdatedAt = moment.unix(val.last_updated_at.seconds);
        //timerSBXリセットを防ぐため一旦コメントアウト
        //if (this.maneuveringLastUpdatedAt) this.setWatchConnectionStateSBX();  // SB-Xの通信状態監視
        this.setWatchConnectionStateAMS();  // AMSの通信状態監視
        this.updateStateTime();
      }
    }
  },
  computed: {
    operationMode() {
      if (this.channelDataManeuvering) {
        return `${this.getOperationModeLabel(
          this.channelDataManeuvering.SB44.vs
        )}`;
      }
    }
  },
  methods: {
    updateStateTime() {
      // 最終更新時刻は操船データの最終更新時刻を採用
      if (this.maneuveringLastUpdatedAt) {
        this.maneuveringLastUpdateAtString = this.maneuveringLastUpdatedAt
          .local()
          .format("YYYY/MM/DD HH:mm:ss");
      } else {
        this.maneuveringLastUpdateAtString = "--/--/-- --:--:--";
      }
      
      if (this.maneuveringLastUpdatedAt && this.engineLastUpdatedAt) {
        if (this.maneuveringLastUpdatedAt.isAfter(this.engineLastUpdatedAt)) {
          this.lastUpdateAt = this.maneuveringLastUpdatedAt;
        } else {
          this.lastUpdateAt = this.engineLastUpdatedAt;
        }
        this.setWatchConnectionState();
      }
    },
    setWatchConnectionState() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      if (this.isDisconnect()) {
        this.setDisconnectState4gVSAT()
      } else {
        // Vue.$log.info(
        //   `[SDF] Stable 4G/VSA connection, last update at ${this.lastUpdateAt.local()}`
        // );
        this.SET_CONNECTING_STATE_4G_VSAT({
          isDisconnect: false,
          localTime: this.lastUpdateAt.local()
        });
        this.setTimerWatchConnectionState();
      }
    },
    setWatchConnectionStateSBX() {
      if (this.timerSBX) {
        clearTimeout(this.timerSBX);
        this.timerSBX = null;
      }
      if (this.isDisconnectManeuvering()) {
        this.setDisconnectStateSBX();
      } else {
        // Vue.$log.info(
        //   `[SDF] Stable SB-X connection, last update at ${this.maneuveringLastUpdatedAt.local()}`
        // );
        this.SET_CONNECTING_STATE_SBX({
          isDisconnect: false,
          localTime: this.maneuveringLastUpdatedAt.local()
        });
        this.setTimerWatchConnectionStateSBX();
      }
    },
    setWatchConnectionStateAMS() {
      if (this.timerAMS) {
        clearTimeout(this.timerAMS);
        this.timerAMS = null;
      }
      if (this.isDisconnectEngine()) {
        this.setDisconnectStateAMS();
      } else {
        // Vue.$log.info(
        //   `[SDF] Stable AMS connection, last update at ${this.engineLastUpdatedAt.local()}`
        // );
        this.SET_CONNECTING_STATE_AMS({
          isDisconnect: false,
          localTime: this.engineLastUpdatedAt.local()
        });
        this.setTimerWatchConnectionStateAMS();
      }
    },
    setTimerWatchConnectionState() {
      this.timer = setTimeout(() => {
        this.setDisconnectState4gVSAT()
      }, 60000 * 2);
    },
    setTimerWatchConnectionStateSBX() {
      this.timerSBX = setTimeout(() => {
        this.setDisconnectStateSBX()
      }, 60000 * 2);
    },
    setTimerWatchConnectionStateAMS() {
      this.timerAMS = setTimeout(() => {
        this.setDisconnectStateAMS()
      }, 60000 * 2);
    },
    isDisconnect() {
      // 2分超えているかどうか
      return moment().diff(this.lastUpdateAt, "minutes") >= 2;
    },
    isDisconnectManeuvering() {
      // SB-Xデータ不到達判定: 2分超えているかどうか
      return moment().diff(this.maneuveringLastUpdatedAt, "minutes") >= 2;
    },
    isDisconnectEngine() {
      // AMSデータ不到達判定: 2分超えているかどうか
      return moment().diff(this.engineLastUpdatedAt, "minutes") >= 2;
    },
    setDisconnectState4gVSAT() {
      Vue.$log.warn(
        `[SDF] Disconnect 4G/VSAT, last update at ${this.lastUpdateAt.local()}`
      );
      this.SET_CONNECTING_STATE_4G_VSAT({
        isDisconnect: true,
        localTime: this.lastUpdateAt.local()
      });
    },
    setDisconnectStateSBX() {
      Vue.$log.warn(
        `[SDF] Disconnect SB-X, last update at ${this.maneuveringLastUpdatedAt.local()}`
      );
      this.SET_CONNECTING_STATE_SBX({
        isDisconnect: true,
        localTime: this.maneuveringLastUpdatedAt.local()
      });
    },
    setDisconnectStateAMS() {
      Vue.$log.warn(
        `[SDF] Disconnect AMS, last update at ${this.engineLastUpdatedAt.local()}`
      );
      this.SET_CONNECTING_STATE_AMS({
        isDisconnect: true,
        localTime: this.engineLastUpdatedAt.local()
      });
    }
  },
  mounted() {},
  beforeDestroy() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
    if (this.timerSBX) {
      clearTimeout(this.timerSBX);
    }
    if (this.timerAMS) {
      clearTimeout(this.timerAMS);
    }
  }
};
</script>

<style lang="scss"></style>
